module.exports = __webpack_public_path__ + "static/media/templates.92657622.svg";